import React, { useState, useEffect } from 'react';
import { Select, Button, notification, Card, Row, Col, Spin } from 'antd';
import styled from 'styled-components';
import { ContainerRow, TitleRow } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { getCopyEligibleUsers, copyK2PTemplates } from '../../../Apis/God';

const RoundedSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 20px !important;
  }
`;

const { Option } = Select;

const CopyK2P = () => {
  const [sourceUsers, setSourceUsers] = useState([]);
  const [targetUsers, setTargetUsers] = useState([]);
  const [sourceUserId, setSourceUserId] = useState(null);
  const [targetUserId, setTargetUserId] = useState(null);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [targetLoading, setTargetLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    setSourceLoading(true);
    getCopyEligibleUsers('SOURCE')
      .then(response => {
        setSourceUsers(response.data.result || response.data || []);
      })
      .catch(() => {
        notification.error({ message: 'Failed to load source users' });
      })
      .finally(() => setSourceLoading(false));

    setTargetLoading(true);
    getCopyEligibleUsers('TARGET')
      .then(response => {
        setTargetUsers(response.data.result || response.data || []);
      })
      .catch(() => {
        notification.error({ message: 'Failed to load destination users' });
      })
      .finally(() => setTargetLoading(false));
  }, []);

  const handleSubmit = () => {
    setSubmitLoading(true);
    copyK2PTemplates(sourceUserId, targetUserId)
      .then(response => {
        notification.success({
          message: 'Success',
          description: response.data.message
        });
        setSourceUserId(null);
        setTargetUserId(null);
      })
      .catch(() => {
        notification.error({ message: 'Failed', description: 'Copy operation failed.' });
      })
      .finally(() => setSubmitLoading(false));
  };

  return (
    <ContainerRow>
      <TitleRow>
        <CustomTypography>Easy k2p-template copying between clinic admins</CustomTypography>
      </TitleRow>

      <Card bordered={false} style={{ borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', width: '100%', marginTop: 32 }}>
        <Row gutter={24}>
          <Col xs={24} md={10}>
            <div style={{ marginBottom: 4, fontWeight: 500 }}>Source</div>
            <Spin spinning={sourceLoading}>
              <RoundedSelect
                placeholder='Select source'
                style={{ width: '100%' }}
                value={sourceUserId}
                onChange={value => setSourceUserId(value)}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {sourceUsers.map(user => (
                  <Option key={user.id} value={user.id}>
                    {user.fullName}
                  </Option>
                ))}
              </RoundedSelect>
            </Spin>
          </Col>

          <Col xs={24} md={10}>
            <div style={{ marginBottom: 4, fontWeight: 500 }}>Destination</div>
            <Spin spinning={targetLoading}>
              <RoundedSelect
                placeholder='Select destination'
                style={{ width: '100%' }}
                value={targetUserId}
                onChange={value => setTargetUserId(value)}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {targetUsers.map(user => (
                  <Option key={user.id} value={user.id}>
                    {user.fullName}
                  </Option>
                ))}
              </RoundedSelect>
            </Spin>
          </Col>
        </Row>

        <Row justify='end' style={{ marginTop: 24 }}>
          <Button
            type='primary'
            shape='round'
            disabled={!sourceUserId || !targetUserId}
            loading={submitLoading}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Row>
      </Card>
    </ContainerRow>
  );
};

export default CopyK2P;
